export const MAX_CREATIVES_AMOUNT = 6;
export const DATE_AND_TIME_FORMAT = 'dd.MM.yyyy, HH:mm';
export const DATE_FORMAT = 'dd.MM.yyyy';
export const BILLING_AMOUNT_FACTOR = 1.2;
export const MIN_DAYS_BEFORE_CAMPAIGN_START = 5;
export const CAMPAIGNS_PER_PAGE = 6;
export const NOTIFICATION_ALERT_TIMEOUT = 5000;

// 50% Discount Campaign Constants
export const DISCOUNT_PERCENTAGE = 50;
export const DISCOUNT_END_DATE = '2025-12-31';
export const DISCOUNT_BADGE_TEXT = '50% Rabatt';
export const DISCOUNT_PROMOTION_TITLE =
  'Profitiere von unserem Rabatt von 50 % auf alle Kampagnen, die bis Ende 2025 erstellt werden.';
export const DISCOUNT_SUCCESS_MESSAGE_TITLE = "50% Rabatt aktiv – so funktioniert's";
export const DISCOUNT_SUCCESS_MESSAGE_DESCRIPTION =
  'Gib dein gewünschtes Budget ein. Du zahlst am Ende nur die Hälfte, bekommst aber die volle Leistung.';
export const DISCOUNT_SIDEBAR_MESSAGE1 = 'Glückwunsch!';
export const DISCOUNT_SIDEBAR_MESSAGE2 = 'Auf diese Kampagne erhältst du 50% Rabatt.';
